export default __webpack_public_path__ + "static/media/navBannerImg3.6559f136.png";